import React from 'react';
import { AssessmentPolicyPage, BasicPageUID } from '@homeproved/com/feature-basic-pages';
import { apiFactory, getDehydratedState, PagesApiFactory } from '@homeproved/shared/data-access';
import { PageWithAuthorization } from '@homeproved/shared/feature-auth';
import { PageShell } from '@homeproved/com/feature-page-shell';

export const Index: PageWithAuthorization = () => (
  <PageShell>
    <AssessmentPolicyPage />
  </PageShell>
);

export async function getServerSideProps({ locale }) {
  const api = apiFactory(locale, PagesApiFactory);
  const uid: BasicPageUID = 'assessment-policy';

  return {
    props: {
      dehydratedState: await getDehydratedState([
        {
          key: uid,
          fn: async () => {
            let response = null;
            await api
              .apiBasicPageBasicPageGet(uid)
              .then((result) => {
                response = result;
              })
              .catch((error) => {
                console.log(error);
              });
            return response.data;
          },
        },
      ]),
      meta: {
        title: 'meta.titles.assessmentPolicy',
        description: 'meta.descriptions.assessmentPolicy',
      },
    },
  };
}

export default Index;
